export function readableDate(date){
  return new Date(date)
    .toLocaleString('uk-UA', { timeZone: 'UTC' })
    .replace('01.01.1970, ', '')
}

export function normalizeCreativeName (name) {
  switch (name) {
    case "promo-landing":
      return "promo";
    default:
      return name;
  }
}
